export function init () {
    const removeElement = document.querySelectorAll('.js-pdfcheckout-remove-variant');

    for(var i = 0; i < removeElement.length; i++) {
        const item = removeElement[i];
        item.addEventListener('click', function(e) {
            const container = item.parentNode;
            container.remove();
        })
    }
}
